import {
  Breadcrumbs,
  Page,
  PageBody,
  PageBreadcrumbs,
  PageHeader,
  PageHeaderTitle,
  PageHeaderDescription,
  PageHeaderTabs,
} from '@customerio/pluma-components/react';
import { Helmet } from 'react-helmet-async';
import { getWorkspaceIdFromCurrentUrl } from '@/context/current-workspace';
import { EmailSettingsTabs } from './components/email-settings-tabs';
import { AccountVerificationContent } from './account-verification-content';

export default function AccountVerificationPage() {
  const workspaceId = getWorkspaceIdFromCurrentUrl();
  const breadcrumbs = [
    { text: 'Workspace settings', href: `/workspaces/${workspaceId}/settings` },
    { text: 'Email', href: `/workspaces/${workspaceId}/settings/actions/email/sending_domains` },
    { text: 'Account verification' },
  ];

  return (
    <>
      <Helmet>
        <title>Account Verification | Customer.io</title>
      </Helmet>
      <Page style={{ width: '100%' }}>
        <PageBreadcrumbs>
          <Breadcrumbs breadcrumbs={breadcrumbs} />
        </PageBreadcrumbs>
        <PageHeader>
          <PageHeaderTitle>Email</PageHeaderTitle>
          <PageHeaderDescription>Manage email settings and configurations for your workspace.</PageHeaderDescription>
          <PageHeaderTabs>
            <EmailSettingsTabs />
          </PageHeaderTabs>
        </PageHeader>
        <PageBody>
          <AccountVerificationContent />
        </PageBody>
      </Page>
    </>
  );
}
